export default {
  title: 'Commission Report',
  tabs: {
    distribution: 'Direct Client Commission',
    agent: 'Agent Commission',
  },
  filter: {
    keyword: 'Client Name / Email',
    accountType: 'Account Type',
    country: 'Country of Residence',
    openDateStart: 'Account Opening Time',
    openDateEnd: 'Account Opening Time',
    lastTradeDateStart: 'Latest Trade Time',
    lastTradeDateEnd: 'Latest Trade Time',
    search: 'Search',
    reset: 'Reset',
  },
  stats: {
    customerCount: 'Customers',
    totalTradeAndUsd: 'Total Trades / million USD',
    totalTradeLotAndUsd: 'Total Lots / million USD',
    totalCommission: 'Total Commission',
  },
  table: {
    levelUnit: 'Level',
    lotUnit: 'Lot',
    action: {
      detail: 'Details',
    },
    columns: {
      customerType: 'Customer Type',
      customerCount: 'Customers',
      tradeVolumeTitle: 'Volume (lots) / million USD',
      yesterdayTotalCommission: 'Yesterday Total Commission',
      tradeCommission: 'Trade Commission',
      followCommission: 'Copy Commission',
      pammCommission: 'PAMM Commission',
      totalCommission: 'Total Commission',
      country: 'Country of Residence',
      name: 'Client Name',
      email: 'Client Email',
      registerTime: 'Registration Time',
      lastTradeTime: 'Latest Trade Time',
      comment: 'Remark',
    },
  },
  detail: {
    levelDistributionTitle: '{level} Level Distribution Commission',
  },
}
